<template>
    <div class="block-text">
        <div v-html="activity.intro"></div>
    </div>
</template>

<script>
export default {
    props: {
        activity: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss">
.block-text {
    padding: 0 15px 25px 15px;
    background-color: $white;
    border-radius: 7px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.05);

    @include media-breakpoint-up(md) {
        padding: 10px 65px 35px 65px;
    }

    @include media-breakpoint-up(lg) {
        padding: 35px 65px;
    }
    &:not(.rte) {
        a {
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }
}

section:first-of-type .block-text {
    @include media-breakpoint-up(xl) {
        margin-top: -150px;
    }
}

.targets {
    list-style: none;
    padding: 0;
    margin: 0;

    i {
        color: $blue-7;
    }
}
</style>
